import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import Delivery from '../deliveries/Delivery';

const SHOW_CALL_CENTER_MAX_DELIVERIES = 4;

const CallCenterWorkSchedule = ApplicationRecord.extend({
  attrs: {
    date: attr({ type: Date }),
    opens_at: attr({ type: Date }),
    closes_at: attr({ type: Date }),
    is_open: attr({ type: Boolean }),
    description: attr(),
  },
  static: {
    endpoint: '/call_center_work_schedules',
    jsonapiType: 'customer_support-call_center_work_schedules',
    // @param {Object} jwt - The decoded payload section of a JWT
    // @param {Date} currentDate - The date to check whether the call center is open. Defaults to today
    // @return {Boolean} true when the call center is open an certain customer-specific criteria are met
    async shouldDisplayPhoneCancellation(jwt, currentDate = new Date()) {
      const isCustomer = jwt.customer_id && !jwt.admin_id;

      if (!isCustomer) {
        return false;
      }

      const callCenterWorkScheduleResponse = await CallCenterWorkSchedule
        .where({ date: { eq: currentDate.toISOString().split('T')[0] } })
        .all();

      if (callCenterWorkScheduleResponse.data[0].is_open === false) {
        return false;
      }

      const deliveriesResponse = await Delivery
        .where({ status: 'billed', delivery_date: { lte: currentDate } })
        .select({ deliveries: ['id'] })
        .stats({ total: 'count' })
        .all();

      const billedDeliveriesCount = deliveriesResponse.meta.stats.total.count;

      return billedDeliveriesCount <= SHOW_CALL_CENTER_MAX_DELIVERIES;
    },
  },
});

export default CallCenterWorkSchedule;
